export default function TextLink({ text, onClick }) {
  return (
    <button
      title={text}
      type="button"
      className="font-bold text-subtitle-light dark:text-subtitle-dark underline py-2 text-center"
      onClick={onClick}
    >
      {text}
    </button>
  );
}
